import { useQueryClient, useMutation, useQuery } from "@tanstack/react-query";
import { dataTableParamsBuilder } from "../../utils/data-table-params-builder";
import { usePaginationQuery } from "../../utils/hooks/use-pagination-query";
import { http } from "../../utils/http";

function fetchProductCodeManagementList(params) {
  const baseUrl = window.location.origin;
  const endpointUrl = new URL("/admin/product-group-codes", baseUrl);

  if (params.categoryId) {
    endpointUrl.searchParams.append("categoryId", params.categoryId);
  }

  if (params.name) {
    endpointUrl.searchParams.append("name", params.name);
  }

  if (params.productNo) {
    endpointUrl.searchParams.append("productNo", params.productNo);
  }

  if (params.productGroupName) {
    endpointUrl.searchParams.append(
      "productGroupName",
      params.productGroupName
    );
  }

  if (params.from) {
    endpointUrl.searchParams.append("from", params.from);
  }
  if (params.to) {
    endpointUrl.searchParams.append("to", params.to);
  }

  if (params.saleStatus) {
    endpointUrl.searchParams.append("saleStatus", params.saleStatus);
  }

  if (params.orderBy) {
    endpointUrl.searchParams.append("orderBy", params.orderBy);
  }

  dataTableParamsBuilder({
    searchParams: endpointUrl.searchParams,
    filterValues: [params.order],
    ...params,
  });

  return http(endpointUrl.toString().replace(baseUrl, ""));
}

export function useProductCodeManagementList(params = {}) {
  return usePaginationQuery(
    [
      "product-group-codes",
      params.keyword,
      params.categoryId,
      params.productGroupName,
      params.name,
      params.productNo,
      params.from,
      params.to,
      params.saleStatus,
      params.orderBy,
    ],
    (paginationState) =>
      fetchProductCodeManagementList({ ...params, ...paginationState })
  );
}
async function addProductLot(formData) {
  const data = await http(`/admin/product-lots`, {
    data: formData,
  });
  return data;
}

export function useAddProductLot() {
  const queryClient = useQueryClient();

  return useMutation(addProductLot, {
    onSuccess: async () => {
      await queryClient.invalidateQueries(["product-groups-code-qr"]);

      // queryClient.refetchQueries(["product-groups-code-qr"]);
    },
  });
}

async function updateProductLot(formData) {
  const data = await http(`/admin/product-lots/${formData?.id}`, {
    data: formData,
    method: "PUT",
  });
  return data;
}

export function useUpdateProductLot() {
  const queryClient = useQueryClient();
  return useMutation(updateProductLot, {
    onSuccess: async () => {
      await queryClient.invalidateQueries(["product-groups-code-qr"]);
    },
  });
}

export async function fetchProductCodeManagementDownload() {
  const { data } = await http(`/admin/product-group-codes-download`, {
    responseType: "blob",
  });

  return data;
}

export async function fetchProductCodeManagementDetailDownload(id) {
  const { data } = await http(`/admin/product-groups-download/${id}`, {
    responseType: "blob",
  });

  return data;
}

export function useProductCodeManagementDownload() {
  const { data, ...raResult } = useQuery(["product-group-codes-download"], () =>
    fetchProductCodeManagementDownload()
  );

  return {
    ...raResult,
    data: data ?? {},
  };
}
